<template>
  <div class="wrapper-ficha noticia">
    <div class="contenedor-evento" v-if="data">
      <div class="formulario-inscripcion" id="formulario" v-if="showinscripcion">
        <h2>Inscríbete a {{ data.title }}</h2>
        <ValidationObserver ref="form" v-slot="{ failed, valid }">
          <form class="paso row-between fww" @submit.prevent="validate" :valid="valid" autocomplete="off">
            <div class="contenedor-input half">
              <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                <input autocomplete="off" type="text" name="nombre" placeholder="Nombre*" v-model="dataform.name"
                  :class="classes" />
                <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{
                  errors[0]
                  }}</span>
              </ValidationProvider>
            </div>

            <div class="contenedor-input half">
              <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                <input autocomplete="off" type="text" name="apellidos" placeholder="Apellidos*"
                  v-model="dataform.surnames" :class="classes" />
                <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{
                  errors[0]
                  }}</span>
              </ValidationProvider>
            </div>

            <div class="contenedor-input half">
              <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                <input autocomplete="off" type="email" name="mail" placeholder="Email*" v-model="dataform.email"
                  :class="classes" />
                <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{
                  errors[0]
                  }}</span>
              </ValidationProvider>
            </div>

            <div class="contenedor-input half">
              <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                <input autocomplete="off" type="text" name="movil" placeholder="Móvil*" v-model="dataform.phone"
                  :class="classes" />
                <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{
                  errors[0]
                  }}</span>
              </ValidationProvider>
            </div>

            <div class="contenedor-input half">
              <ValidationProvider rules="numeric|max_value:2" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                <input autocomplete="off" type="number" name="companions" placeholder="Número de acompañantes"
                  v-model="dataform.companions" :class="classes" />
                <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{
                  errors[0]
                  }}</span>
              </ValidationProvider>
            </div>

            <div class="contenedor-input half" v-if="data.type === 0">
              <ValidationProvider :rules="{ notZero: true }" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                <select id="attendance_preference" name="attendance_preference" v-model="dataform.type"
                  :class="classes">
                  <option value=0 disabled>Preferencia de asistencia*</option>
                  <option value="1">Presencial</option>
                  <option value="2">Online</option>
                </select>
                <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{
                  errors[0]
                  }}</span>
              </ValidationProvider>
            </div>
            <div class="container-text-legal">
              <p><strong>Información básica sobre protección de datos personales </strong></p>
              <p><strong>Responsable del tratamiento</strong>: Fundación Universidad Francisco de Vitoria (UFV). Los
                datos de contacto de la UFV son los siguientes: </p>
              <ul>
                <li>Dirección postal: Ctra. M-515 Pozuelo-Majadahonda Km. 1.800, 28223 Pozuelo de Alarcón, Madrid.
                  Dirección electrónica: secretariageneral@ufv.es </li>

                <li>Teléfono: <a href="tel:+91 709 14 00">+34 91 709 14 00</a> </li>

                <li>Las Personas Interesadas pueden contactar con la Oficina del Delegado de Protección de Datos de la
                  UFV en la dirección electrónica: <a href="mailto:dpd@ufv.es.">dpd@ufv.es.</a> </li>
              </ul>
              <p><strong>Legitimación y finalidades del tratamiento:</strong> con base jurídica en el consentimiento
                otorgado por la
                Persona Participante mediante la marcación de la correspondiente casilla destinada al efecto, sus
                datos personales serán tratados con la finalidad de gestionar su participación en {{ data.title }}.</p>
              <p>
                <strong>Destinatarios:</strong> sus datos personales no serán comunicados a terceras personas. No
                obstante, con base jurídica en el cumplimiento de obligaciones legales, sus datos personales podrán
                ser comunicados a autoridades administrativas y órganos judiciales con competencia en la materia
                cuando así se establezca en la normativa aplicable. Igualmente, terceros encargados del tratamiento
                podrán tener acceso a los Datos Personales para la prestación de servicios, al amparo y previa
                suscripción de un contrato de encargo de tratamiento y confidencialidad de la información.
              </p>
              <p><strong>Derechos:</strong> acceso, rectificación, supresión, limitación, oposición, portabilidad, a
                retirar el consentimiento sin que ello afecte a la licitud del tratamiento basado en el consentimiento
                previo a su retirada, a no ser objeto de una decisión basada únicamente en el tratamiento
                automatizado, incluida la elaboración de perfiles y a presentar una reclamación ante una autoridad de
                control. </p>
              <p><strong>Información adicional sobre protección de datos: </strong><a
                  href="https://www.ufv.es/politica-de-privacidad-eventosufv/" target="_blank"
                  rel="noopener noreferrer">https://www.ufv.es/politica-de-privacidad-eventosufv/</a> </p>

            </div>
            <div class="contenedor-input">
              <ValidationProvider rules="required" v-slot="{ errors, ariaInput, ariaMsg, classes }">
                <input type="checkbox" id="contact" v-model="dataform.privacy_check" :class="classes" />
                <label for="contact">Acepto y autorizo a que mis datos sean tratados por la
                  Universidad Francisco de Vitoria, con las finalidades
                  indicadas anteriormente y para remitirme, por cualquier medio,
                  incluidos los electrónicos (SMS, Whatsapp, correo electrónico
                  y redes sociales) las comunicaciones correspondientes.*</label>
                <span v-bind="ariaMsg" class="custom-error" v-if="errors[0]">{{
                  errors[0]
                  }}</span>
              </ValidationProvider>
            </div>

            <div class="contenedor-boton">
              <div class="contenedor-boton row-start">
                <button class="boton-azul" :loading="loading">
                  Inscribirse
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <div class="popup" v-if="showpopup">
      <div class="paso" v-if="hasToRegister">
        <span class="close" @click="showpopup = !showpopup">X</span>
        <h2 class="titulo" style="text-align: center; margin-bottom: 15px">
          <strong>¡Atención!</strong>
        </h2>

        <p>
          El email que ha indicado no consta como usuario registrado de Alumni
          UFV. Para apuntarse a este evento, pulse a continuación:
        </p>

        <router-link class="boton-azul" :to="`/es/general/registro-alumni?event_id=${dataform.event_id}`">
          Registrarme y apuntarme al evento
        </router-link>
      </div>
      <div class="paso" v-else>
        <span class="close" @click="showpopup = !showpopup">X</span>
        <h2 class="titulo" style="text-align: center">
          <strong>Enhorabuena</strong>
        </h2>

        <p>Tu inscripción se ha realizado correctamente.</p>

        <p>
          Te mantendremos informado de todas nuestras actividades por correo
          electrónico.
        </p>

        <p>
          Cualquier consulta puedes escribirnos a
          <a href="mailto:alumni@ufv.es"><u>alumni@ufv.es.</u></a>
        </p>

        <a @click="showpopup = false" class="boton-azul">Aceptar</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import router from "@/router";
import { extend } from "vee-validate";

extend("notZero", {
  validate: (value) => value !== 0,
  message: "Debes seleccionar una opción válida.",
});
export default {
  name: "evento-abierto",
  data: () => ({
    data: "",
    loading: false,
    hasToRegister: false,
    dataform: {
      name: "",
      surnames: "",
      email: "",
      phone: "",
      privacy_check: "",
      event_id: "",
      attendance_preference: "",
      companions: "",
      type: null,
    },
    showpopup: false,
  }),
  methods: {
    ...mapActions(["requestEvento", "requestInscripcionAbierta"]),
    setData() {
      this.requestEvento(this.$route.params.id).then((r) => {
        this.data = r;
        this.dataform.event_id = r.id;
        this.dataform.type = r.type;
      });
    },
    back() {
      router.go(-1);
    },
    validate() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.loading = true;
          this.inscripcion();
        }
      });
    },
    inscripcion() {
      this.loading = true;

      if (!this.dataform.companions) {
        this.dataform.companions = null;
      }

      this.requestInscripcionAbierta(this.dataform).then((r) => {
        this.loading = false;
        this.hasToRegister = false;
        if (r == 403) {
          this.hasToRegister = true;
        }
        if (r) {
          this.dataform = {
            name: "",
            surnames: "",
            email: "",
            phone: "",
            privacy_check: "",
            event_id: "",
            attendance_preference: "",
            type: this.data.type,
          };
          this.showpopup = true;
          this.dataform.event_id = this.data.id;
        }
        this.$refs.form.reset();
      });
    },
    todown() {
      scroll({
        top: document.getElementById("formulario").getBoundingClientRect().top,
        behavior: "smooth",
      });
    },
  },
  computed: {
    ...mapGetters({
      dominios: "getDominios",
    }),
    fechaactual() {
      let pasada = new Date(this.data.date).getTime();
      let actual = new Date().getTime();

      return actual > pasada;
    },
    showinscripcion() {
      let can = false;
      if (this.data && this.data.open) {
        let date = new Date().setHours(0, 0, 0, 0);
        let close_date = new Date(this.data.date).setHours(0, 0, 0, 0);

        if (date <= close_date) {
          can = true;
        }
      }

      return can;
    },
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      handler() {
        this.setData();
      },
    },
    studyHaseluFlag() {
      if (!this.dataform.study || !this.dataform.study[0]) {
        return;
      }
      const s = this.dataform.study[0];
      s.study = null;
      s.level = '';
      s.year = '';
      s.elu_year = '';
      s.university = null;
      this.setNiveles([]);
    },
  },
};
</script>

<style lang="scss" scoped>
$azul: #003466;

.formulario-inscripcion {
  width: 100%;

  h2 {
    font-size: 30px;
    line-height: 1.2;
    margin-bottom: 30px;
  }
}

.contenedor-input {
  padding-bottom: 20px;

  select {
    width: 100%;
  }
}

.wrapper-ficha .contenedor-evento p {
  margin-bottom: 0;
}

// Título de sección "Datos académicos" — separador visual
.datos-academicos-titulo {
  width: 100%;

  strong {
    font-size: 18px;
  }
}

// Pregunta ELU (radios Sí/No)
.more-options {
  h5 {
    font-size: 15px;
    line-height: 1.4;
    font-weight: 700;
    margin-bottom: 12px;
  }

  input[type="radio"]+label {
    margin-right: 28px;
  }
}

// Textos informativos
.msg-info-tel {
  line-height: 1.5;
  margin-bottom: 8px;
}

// Bloque legal de protección de datos
.container-text-legal {
  width: 100%;

  p,
  li {
    line-height: 1.55;
  }
}

// Consentimiento + botón
.contenedor-boton {
  width: 100%;
  margin-top: 12px;
}

@media screen and (max-width: 768px) {
  .formulario-inscripcion h2 {
    font-size: 24px;
    margin-bottom: 22px;
  }

  .datos-academicos-titulo {
    padding-top: 20px;

    strong {
      font-size: 17px;
    }
  }
}

@media screen and (max-width: 500px) {
  .formulario-inscripcion h2 {
    font-size: 21px;
  }

  .more-options input[type="radio"]+label {
    margin-right: 22px;
  }
}

.popup {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
  height: 100%;
  max-width: 100%;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .paso {
    max-width: 500px;
    background: white;
    padding: 20px;
  }

  .close {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
    font-size: 25px;
    font-weight: 700;
  }
}
</style>
